import { render, staticRenderFns } from "./EditManualCategory.vue?vue&type=template&id=43be5249&scoped=true&"
import script from "./EditManualCategory.vue?vue&type=script&lang=js&"
export * from "./EditManualCategory.vue?vue&type=script&lang=js&"
import style0 from "./EditManualCategory.vue?vue&type=style&index=0&id=43be5249&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43be5249",
  null
  
)

export default component.exports